import { render, staticRenderFns } from "./ProjectNew.vue?vue&type=template&id=7c0c7e08"
import script from "./ProjectNew.vue?vue&type=script&lang=ts"
export * from "./ProjectNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports